import type { FC } from 'react'
import { Fragment, lazy, Suspense } from 'react'

import type { ChatContainerProps } from './ChatContainer.types'

const Component = lazy(() => import('./ChatContainer'))

/**
 * Lazy loaded version of ChatContainer component
 */
export const ChatContainer: FC<ChatContainerProps> = (props) => (
  <Suspense fallback={<Fragment />}>
    <Component {...props} />
  </Suspense>
)
